const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the in app message template component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('teamsTemplate', [
  function () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        contentType: '=',
        content: '=',
      },
      template: require('../../../templates/directives/messaging/teams-template.html'),
      controller: [
        '$scope',
        function ($scope) {
          var self = this;
          self.body = '';
          if (!$scope.content || !$scope.content.messaging) {
            return;
          }
          if (!$scope.content.messaging.teams) {
            $scope.content.messaging.teams = [];
          }

          $scope.content.messaging.teams.forEach(function (item) {
            if (item.name === 'body') {
              self.body = item.value.slice(0);
            }
          });

          self.replacements = {
            showDropdown: false,
            options: {
              Workshop: {
                recipient_first_name: 'Recipient First Name',
                recipient_last_name: 'Recipient Last Name',
                sender_first_name: 'Sender First Name',
                sender_last_name: 'Sender Last Name',
                workshop_title: 'Workshop Title',
                host_name: 'Host Name',
              },
              assignment: {
                due_in: 'Due from now in Days',
                assigner_first_name: 'Assigner First Name',
                assigner_last_name: 'Assigner Last Name',
                assignee_first_name: 'Assignee First Name',
                assignee_last_name: 'Assignee Last Name',
                recipient_first_name: 'Recipient First Name',
                recipient_last_name: 'Recipient Last Name',
              },
            },
            insertVariable: function (key) {
              key = '{' + key + '}';
              var elem = document.getElementById('dm-teams-message');
              if (elem.selection) {
                // IE
                elem.focus();
                var sel = elem.selection.createRange();
                sel.text = key;
              } else if (elem.selectionStart || elem.selectionStart === 0) {
                // Others
                var startPos = elem.selectionStart;
                var endPos = elem.selectionEnd;
                elem.value =
                  elem.value.substring(0, startPos) +
                  key +
                  elem.value.substring(endPos, elem.value.length);
                elem.selectionStart = startPos + key.length;
                elem.selectionEnd = startPos + key.length;
              } else {
                elem.value += key;
              }
              self.replacements.showDropdown = false;
            },
          };

          self.update = function () {
            var bodySet = false;

            $scope.content.messaging.teams.forEach(function (item) {
              if (item.name === 'body') {
                item.value = self.body;
                bodySet = true;
              }
            });

            if (!bodySet) {
              $scope.content.messaging.teams.push({ name: 'body', value: self.body });
            }
          };
        },
      ],
      controllerAs: 'teamsMessage',
    };
  },
]);
